<template>
    <div>
      <el-form size="mini">
        <el-row>
            <el-col :span="12" >
                <el-form-item label="应用名称">
                    <el-select style="width: 200px;" filterable clearable v-model="selectedAppId" @change="changeSelectedAppId" @clear="clearSelectedAppId"  placeholder="请选择">
                        <el-option
                            v-for="item in appsList"
                            :key="item.id"
                            :label="item.label"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12" >
              <el-form-item label="流程模板">
                <el-select style="width: 200px;" v-model="processServiceId" @change="changeProcessList"  placeholder="请选择">
                    <el-option
                        v-for="(item,index) in currentTemplateList"
                        :key="index"
                        :label="item.templateName"
                        :value="item.processServiceId">
                    </el-option>
                </el-select>
              </el-form-item>
           </el-col>
        </el-row>
        <el-row v-if="mainsubTag">
          <el-col :span="12" >
             <el-form-item label="流程范围">
               <el-select style="width: 200px;" v-model="processMode"  @change="changeProcessModeList" placeholder="请选择">
                   <el-option
                       v-for="item in processModeArr"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
                   </el-option>
               </el-select>
             </el-form-item>
          </el-col>
           <!-- <el-col :span="12" >
               <el-form-item label="标签范围">
                <el-tooltip content="选择全部时可以查出配置标签和未配置标签的所有档案文件，选择有标签时只查出配置了标签的档案文件" placement="top">
                  <el-select style="width: 200px;" v-model="tagMode" @change="changeTagModeList"  placeholder="请选择">
                    <el-option
                        v-for="item in tagModeArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col> -->
       </el-row>
        <el-row>
           <el-col :span="12" >
              <el-form-item label="流程状态">
                <el-select style="width: 200px;" v-model="processState"  @change="changeProcessList" placeholder="请选择">
                    <el-option
                        v-for="item in processStateArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
           </el-col>
            <el-col :span="12" >
                <el-form-item label="流程名称">
                    <el-input style="width: 200px;" readonly v-model="selectedProcess.selectedProcessNames" @focus="chooseProcess"></el-input> 
                </el-form-item>
           </el-col>
        </el-row>
      </el-form>
      <ProcessSelectPop
        :multiple="false"
        :isShowProcessPop="isShowProcessPop"
        :selectedProcess="selectedProcess"
        :formData="{}"
        :field="{}"
        :hideBtn="hideBtn"
        @nodeClick="confirmChooseProcess"
        ref="processPop"
      />
    </div>
</template>

<script>
    import { getPublishedApplicationList, getAllProcessInstancesList, getProcessInstancesList, getProcessTemplateList } from '@/data-model';
    import { isEmpty } from 'lodash';

    export default {
        data () {
            return {
                selectedProcess: {
                    processIds: '',
                    selectedProcessNames: ''
                },
                isShowProcessPop: false,
                selectedAppId: '',
                selectedApp: {},
                currentTemplateList: [],
                appsList: [],
                loading: false,
                processList: [],
                selectProcesss: [],
                mutilProcesss: '',
                selected: {
                    id: '',
                    name: ''
                },
                selectProcess: '',
                processState: 1, // 默认进行中
                processStateArr: [
                    {
                        value: null,
                        label: '全部'
                    },
                    {
                        value: 1,
                        label: '进行中'
                    }, {
                        value: 2,
                        label: '已完成'
                    }],
                processMode: 99, // 默认进全部
                processModeArr: [
                    {
                        value: 99,
                        label: '全部'
                    },
                    {
                        value: 1,
                        label: '主流程'
                    }, {
                        value: 2,
                        label: '子流程'
                    }],
                tagMode: 99, // 默认进全部
                tagModeArr: [
                    {
                        value: 99,
                        label: '全部'
                    },
                    {
                        value: 1,
                        label: '含标签'
                    }
                    // {
                    //     value: 2,
                    //     label: '无标签'
                    // }
                ],
    
                processTemplateList: [],
                processServiceId: ''
            };
        },
        props: {
            field: {
                type: Object,
                required: true
            },
            formData: {
                type: Object,
                required: true
            },
            multiple: {
                type: Boolean,
                required: false
            },
            fromBI: {
                type: Boolean,
                default: false
            },
            unNeedAuth: {
                type: Boolean,
                default: false
            },
            filterTimeFlg: {
                type: Boolean,
                default: false
            },
            mainsubTag: {// 是否查主子流程及标签过滤
                type: Boolean,
                default: false
            },
            hideBtn:{
                type: Boolean,
                default: false
            }
        },
        created () {
            console.log(this.hideBtn);
            this.getApplications();
            // this.queryProcessList('');
            this.initProcessTemplateList();
        },
        methods: {
            async getApplications () {
                this.appsList = await getPublishedApplicationList();
            },
            clearSelectedAppId () {
                this.processServiceId = '';
                this.currentTemplateList = this.processTemplateList;
                // 刷新流程列表信息
                this.changeProcessList();
            },
            changeSelectedAppId () {
                // console.log(this.appsList);
                // console.log(this.selectedAppId);
                this.processServiceId = '';
                if (this.selectedAppId) {
                    // 根据APPId获取应用
                    for (let j = 0; j < this.appsList.length; j++) {
                        let app = this.appsList[j];
                        if (app.id === this.selectedAppId) {
                            this.selectedApp = app;
                        }
                    }
                    // 根据应用获取绑定的流程模板
                    if (this.selectedApp) {
                        if (!isEmpty(this.selectedApp.processServiceIds)) {
                            let processServiceIds = this.selectedApp.processServiceIds.split(',');
                            let processServiceNames = this.selectedApp.processServiceNames.split(',');
                            let selectedData = [];
                            for (let i = 0; i < processServiceIds.length; i++) {
                                selectedData.push({processServiceId: processServiceIds[i], templateName: processServiceNames[i]});
                            }
                            this.currentTemplateList = selectedData;

                            this.processServiceId = this.currentTemplateList[0].processServiceId;
                            // 刷新流程列表信息
                            this.changeProcessList();
                        } else {
                            this.currentTemplateList = [];
                            this.processList = [];
                        }
                    } else {
                        this.currentTemplateList = this.processTemplateList;
                    }
                } else {
                    this.currentTemplateList = this.processTemplateList;
                }
            },
            async changeProcessList () {
                this.queryProcessList('');
            },

            async changeProcessModeList () {
                // this.queryProcessList('');
                // this.$emit('nodeClick', {id: this.selected.id, label: this.selected.name, processMode: this.processMode});
            },
            async initProcessTemplateList () {
                let param = {
                    state: 1,
                    unNeedAuth: this.unNeedAuth,
                    currentPage: 0,
                    pageSize: 10000
                };
                let { data } = await getProcessTemplateList(param);// 查出最新版本的流程方案
                this.processTemplateList = data;
                this.currentTemplateList = data;
            },
            async queryProcessList (name) {
                this.loading = true;
                if (this.unNeedAuth) {
                    let { data } = await getAllProcessInstancesList({
                        pageSize: 10000,
                        currentPage: 1,
                        serviceName: name,
                        state: this.processState,
                        processMode: this.processMode,
                        processServiceId: this.processServiceId
                    });
                    this.processList = data;
                } else {
                    let { data } = await getProcessInstancesList({
                        pageSize: 10000,
                        currentPage: 1,
                        serviceName: name,
                        state: this.processState,
                        fromBI: this.fromBI,
                        processMode: this.processMode,
                        filterTimeFlg: this.filterTimeFlg,
                        processServiceId: this.processServiceId
                    });
                    this.processList = data;
                }
                this.loading = false;
            },
            selectTrigger (val) {
                if (this.multiple) {
                    if (this.formData) {
                        if (val) {
                            let names = [];
                            this.processList.find((item) => {
                                val.find((it) => {
                                    if (item.id === it) {
                                        names.push(item.name);
                                    }
                                });
                            });
                            this.formData[this.field.formField] = val.join(',');
                            this.formData[this.field.formField + '-Process'] = names.join(',');
                        } else {
                            this.processList = [];
                            this.formData[this.field.formField] = '';
                            this.formData[this.field.formField + '-Process'] = '';
                        }
                    }
                } else {
                    if (val) {
                        this.selected = this.processList.find((item) => {
                            return item.id === val;
                        });
                    } else {
                        this.selected = {id: '', name: ''};
                    }
                    if (this.formData) {
                        this.formData[this.field.formField] = this.selected.idd;
                        this.formData[this.field.formField + '-Process'] = this.selected.name;
                    }
                }
                this.$emit('nodeClick', {id: this.selected.id, label: this.selected.name, processMode: this.processMode});
            },
            chooseProcess () {
                this.isShowProcessPop = true;
                // 初始化
                if (this.$refs.processPop) {
                    this.$refs.processPop._initPage();
                }
            },
            confirmChooseProcess () {
                this.isShowProcessPop = false;
                // console.log(this.selectedProcess);
                let selectedProcess = this.$refs.processPop.confirmClick();
                this.selectedProcess = selectedProcess;
                return {id: selectedProcess.selectedProcessIds, label: selectedProcess.selectedProcessNames}
                // this.$emit('nodeClick', {id: selectedProcess.selectedProcessIds, label: selectedProcess.selectedProcessNames});
            }
            // changeTagModeList () {
            //     this.$emit('nodeClick', {id: this.selected.id, label: this.selected.name, processMode: this.processMode, tagMode: this.tagMode});
            // }
        }
    };
</script>
<style lang="less">
.el-select-dropdown{
    width: 40vw;
}
</style>



// WEBPACK FOOTER //
// src/components/ProcessPop/ProcessPop.vue